export default __webpack_public_path__ + "static/media/gse.d524d299.png";